import { Action } from '../../actions';
import { ADD_CREATED_INTERNAL_PRODUCT } from '../../actions/products/internal/addCreatedInternalProduct';
import { CREATE_INTERNAL_PRODUCT } from '../../actions/products/internal/createInternalProduct';
import { LOAD_INTERNAL_PRODUCTS } from '../../actions/products/internal/loadInternalProducts';
import { SEARCH_INTERNAL_PRODUCTS } from '../../actions/products/internal/searchInternalProducts';
import { SORT_INTERNAL_PRODUCTS } from '../../actions/products/internal/sortInternalProducts';
import { UPDATE_INTERNAL_PRODUCT } from '../../actions/products/internal/updateInternalProduct';
import { UPDATE_INTERNAL_PRODUCT_DESCRIPTION } from '../../actions/products/internal/updateInternalProductDescription';
import { UPDATE_INTERNAL_PRODUCTS } from '../../actions/products/internal/updateInternalProducts';
import { UPDATE_INTERNAL_PRODUCTS_FORM } from '../../actions/products/internal/updateInternalProductsForm';
import { UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS } from '../../actions/products/internal/updateInternalProductsPageStatus';
import { ProductsPageStates, ProductsState } from '../../typings/products';

import { addCreatedInternalProduct } from './internal/addCreatedInternalProduct';
import { createInternalProduct } from './internal/createInternalProduct';
import { loadInternalProducts } from './internal/loadInternalProducts';
import { searchInternalProducts } from './internal/searchInternalProducts';
import { sortInternalProducts } from './internal/sortInternalProducts';
import { updateInternalProduct } from './internal/updateInternalProduct';
import { updateInternalProductDescription } from './internal/updateInternalProductDescription';
import { updateInternalProducts } from './internal/updateInternalProducts';
import { updateInternalProductsForm } from './internal/updateInternalProductsForm';
import { updateInternalProductsPageStatus } from './internal/updateInternalProductsPageStatus';

export const getProductsInitialState = (): ProductsState => ({
    products: [],
    filtered: [],
    pageStatus: ProductsPageStates.PENDING,
    productsForm: {
        product: {
            productName: '',
            description: ''
        },
        isValid: true,
        isEnabled: false
    },
    isFiltered: false
});

export function internalProducts(state: ProductsState = getProductsInitialState(), action: Action): ProductsState {
    switch (action.type) {
        case LOAD_INTERNAL_PRODUCTS:
            return loadInternalProducts(state, action);

        case UPDATE_INTERNAL_PRODUCTS:
            return updateInternalProducts(state, action);

        case ADD_CREATED_INTERNAL_PRODUCT:
            return addCreatedInternalProduct(state, action);

        case UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS:
            return updateInternalProductsPageStatus(state, action);

        case UPDATE_INTERNAL_PRODUCT_DESCRIPTION:
            return updateInternalProductDescription(state, action);

        case UPDATE_INTERNAL_PRODUCT:
            return updateInternalProduct(state, action);

        case SORT_INTERNAL_PRODUCTS:
            return sortInternalProducts(state, action);

        case CREATE_INTERNAL_PRODUCT:
            return createInternalProduct(state, action);

        case UPDATE_INTERNAL_PRODUCTS_FORM:
            return updateInternalProductsForm(state, action);

        case SEARCH_INTERNAL_PRODUCTS:
            return searchInternalProducts(state, action);

        default:
            return state;
    }
}
